export default __webpack_public_path__ + "static/media/into-the-wild.ed8696de.mp4";